module.exports = __webpack_public_path__ + "static/ADOLESCENT-f878df7b80179e896952f3b9eba4f553.png";